import axios from 'axios';
import * as qs from 'qs';
export default class HttpClient {
    apiClient;
    httpParseResponse;
    constructor(uri, headers = {}) {
        const apiClient = axios.create({
            baseURL: uri,
            withCredentials: true,
            headers,
        });
        apiClient.interceptors.response.use((response) => response, (error) => Promise.reject(error));
        this.apiClient = apiClient;
    }
    /**
     * Request
     *
     * @param method
     * @param path
     * @param params
     * @param data
     * @param headers
     */
    async request(method, path, params, data, headers) {
        return this.apiClient.request({
            method,
            params,
            headers,
            data,
            url: path,
            paramsSerializer: (query) => qs.stringify(query, { encode: false }),
        });
    }
    /**
     * Request As file
     *
     * @param method
     * @param path
     * @param params
     * @param data
     * @param headers
     */
    async file(method, path, params, data, headers) {
        return this.apiClient.request({
            method,
            params,
            headers,
            data,
            url: path,
            responseType: 'arraybuffer',
            paramsSerializer: (query) => qs.stringify(query, { encode: false }),
        });
    }
    /**
     *
     * @param response
     * @param paginate
     */
    parseResponse(response, paginate) {
        if (!response.headers['x-json-api-version']) {
            return response.data;
        }
        return this.httpParseResponse
            .setResponse(response)
            .parser(paginate);
    }
}
